export default __webpack_public_path__ + "static/media/mobilefylo.b742019f.png";